import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureFlagsState } from './types';

export const FeatureFlagsKey = 'feature-flags';

const featureFlagsState = createFeatureSelector<FeatureFlagsState>(FeatureFlagsKey);

export const getFeatureFlags = createSelector(featureFlagsState, (state) => state.flags);

export const getFeatureFlagsLoaded = createSelector(featureFlagsState, (state) => state?.loaded);

export const isFeatureFlagEnabled = (flagName: string) =>
  createSelector(getFeatureFlags, (state) => !!state?.[flagName]);

export const isFeatureFlagDisabled = (flagName: string) =>
  createSelector(getFeatureFlags, (state) => !state?.[flagName]);
